import { Route, Switch, useHistory } from 'react-router-dom';
import FlyoutLeft from '../../components/common/FlyoutLeft';
import OverlayFlyoutRight from '../../components/common/OverlayFlyoutRight';
import { useCommonStore } from '../../stores/commonStore';
import { Routes } from '../../utils/constants/routes';
import Home from './Home';
import Requests from './Requests';
import ProductsDetails from '../Common/ProductDetails';
import RequestDetails from '../Common/RequestDetails';
import { useRequestorStore } from '../../stores/requestorStore';
import ToastMessageDialogue from '../../components/common/ToastMessageDialogue';
import SideNavigationBar from '../../components/common/SideNavigationBar';
import Products from '../Common/Products';
import ModelUploader from './ModelUploader';
import Reviews from '../Common/Reviews';
import RequestBreakDown from '../Common/RequestBreakdown';
import { clearAndHandleLogout } from '../../utils/authUtils';
import BulkUploadStatus from './BulkUploadStatus';

const Requester = () => {
    const sideBarOpen: boolean = useCommonStore((state) => state.sideBarOpen);
    const activeRequest = useRequestorStore((state) => state.activeRequest);
    const setActiveRequest = useRequestorStore((state) => state.setActiveRequest);
    const activeProduct = useRequestorStore((state) => state.activeProduct);
    const setActiveProduct = useRequestorStore((state) => state.setActiveProduct);
    const showActiveRequest = useRequestorStore((state) => state.showActiveRequest);
    const showActiveProduct = useRequestorStore((state) => state.showActiveProduct);
    const history = useHistory();

    const handleLogout = () => {
        localStorage.clear();
        // window.location.reload();
        history.push(Routes.LOGIN);
        // clearAndHandleLogout();
    };

    const handleFlyoutClose = () => {
        if (activeRequest) setActiveRequest(null);
        if (activeProduct) setActiveProduct(null);
    };

    return (
        <main className="flex container-height">
            <ToastMessageDialogue />
            <OverlayFlyoutRight>
                <>
                    {showActiveRequest && <RequestDetails />}
                    {showActiveProduct && <ProductsDetails />}
                </>
            </OverlayFlyoutRight>
            <FlyoutLeft open={sideBarOpen}>
                <div className="flex flex-col content-center h-full">
                    <div className="bg-white h-full dark:bg-gray-700 my-12">
                        <SideNavigationBar type="vendor" />
                    </div>
                    <div className="mt-auto">
                        <button onClick={handleLogout} className="w-full font-thin capitalize text-gray-500 dark:text-gray-200 flex items-center p-4 transition-colors duration-200 justify-start">
                            <span className="text-left">
                                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="fill-current text-red-500">
                                    <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" />
                                </svg>
                            </span>
                            <span className="mx-5 text-sm font-normal whitespace-nowrap text-red-600">Logout</span>
                        </button>
                    </div>
                </div>
            </FlyoutLeft>
            <section className="overflow-auto w-full">
                <Switch>
                    <Route path={Routes.VENDOR_ROUTES.REQUESTS} exact>
                        <Requests />
                    </Route>
                    <Route path={Routes.VENDOR_ROUTES.REVIEWS} exact>
                        <Reviews />
                    </Route>

                    <Route path={Routes.VENDOR_ROUTES.PRODUCTS_LIST} exact>
                        <Products />
                    </Route>
                    <Route path={Routes.VENDOR_ROUTES.REQUEST_BREAKDOWN_LIST} exact>
                        <RequestBreakDown />
                    </Route>
                    <Route path={Routes.VENDOR_ROUTES.ROOT} exact>
                        <Home />
                    </Route>
                    <Route path={Routes.VENDOR_ROUTES.UPLOAD_3D_MODELS} exact>
                        <ModelUploader />
                    </Route>
                    <Route path={Routes.VENDOR_ROUTES.UPLOAD_STATUS} exact>
                        <BulkUploadStatus />
                    </Route>
                </Switch>
            </section>
        </main>
    );
};

export default Requester;
